import { useEffect, useRef } from 'react';

declare global {
    interface Window {
        FreeScoutW?: any;
    }
}

const HelpWidget = () => {
    const widgetInitialized = useRef(false);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const buttonRef = useRef<HTMLDivElement | null>(null);

    // Инициализация виджета
    const initWidget = () => {
        if (widgetInitialized.current) return;

        const token = localStorage.getItem('jwt');
        let userId = '';

        try {
            if (token) {
                const [, base64Url] = token.split('.');
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split('')
                        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                userId = JSON.parse(jsonPayload).uid;
            }
        } catch (error) {
            console.error('JWT parsing error:', error);
        }

        window.FreeScoutW = {
            f: { cf_1: userId },
            s: {
                cf: ['1'],
                color: '#4589b5',
                position: 'bl',
                locale: 'ru',
                id: 2361010349
            }
        };

        // Создаем элементы виджета
        const iframe = document.createElement('iframe');
        iframeRef.current = iframe;
        iframe.id = 'fsw-iframe';
        iframe.style.cssText = `
      width: 342px;
      height: 500px;
      background-color: #ffffff;
      position: fixed;
      bottom: 16px;
      right: 16px;
      max-height: calc(100vh - 32px);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 0.428571rem 0px;
      overflow: hidden;
      border: 0;
      z-index: 1099;
      border-radius: 10px;
      display: none;
    `;

        const button = document.createElement('div');
        buttonRef.current = button;
        button.id = 'fsw-btn';
        button.style.cssText = `
      background-color: #4589b5;
      position: fixed;
      bottom: 12px;
      right: 19px;
      height: 50px;
      width: 50px;
      z-index: 1099;
      padding: 14px;
      cursor: pointer;
      line-height: 21.5px;
      color: #ffffff;
      text-align: center;
      border-radius: 50%;
    `;

        button.innerHTML = `
      <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M256%2032C114.6%2032%200%20125.1%200%20240c0%2047.6%2019.9%2091.2%2052.9%20126.3C38%20405.7%207%20439.1%206.5%20439.5c-6.6%207-8.4%2017.2-4.6%2026S14.4%20480%2024%20480c61.5%200%20110-25.7%20139.1-46.3C192%20442.8%20223.2%20448%20256%20448c141.4%200%20256-93.1%20256-208S397.4%2032%20256%2032zm0%20368c-26.7%200-53.1-4.1-78.4-12.1l-22.7-7.2-19.5%2013.8c-14.3%2010.1-33.9%2021.4-57.5%2029%207.3-12.1%2014.4-25.7%2019.9-40.2l10.6-28.1-20.6-21.8C69.7%20314.1%2048%20282.2%2048%20240c0-88.2%2093.3-160%20208-160s208%2071.8%20208%20160-93.3%20160-208%20160z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E" 
        style="transform: scaleX(-1); width: 100%; height: 100%;" 
        alt="Chat"
      />
    `;

        // Обработчики событий
        const showHandler = () => {
            if (iframeRef.current) {
                iframeRef.current.style.display = 'block';
                button.style.display = 'none';
            }
        };

        const minimizeHandler = () => {
            if (iframeRef.current && buttonRef.current) {
                iframeRef.current.style.display = 'none';
                buttonRef.current.style.display = 'block';
            }
        };

        button.addEventListener('click', showHandler);
        window.addEventListener('message', e => {
            if (e.data === 'fsw.minimize') minimizeHandler();
        });

        document.body.appendChild(iframe);
        document.body.appendChild(button);

        // Загрузка iframe
        iframe.src = `https://help.unitxml.ru/help/widget/form/2361010349?${new URLSearchParams({
            color: '#4589b5',
            position: 'bl',
            locale: 'ru',
            ...(userId && { 'f[cf_1]': userId })
        })}`;

        widgetInitialized.current = true;
    };

    useEffect(() => {
        initWidget();

        return () => {
            // Очистка при размонтировании
            if (iframeRef.current) document.body.removeChild(iframeRef.current);
            if (buttonRef.current) document.body.removeChild(buttonRef.current);
            window.FreeScoutW = undefined;
        };
    }, []);

    return null;
};

export default HelpWidget;